export default function quickMenuOpen(){
    const way = "calendar/menuOpen"; 
    this.dataSet(way,!this.dataGet(way))
  }
